import classnames from 'classnames'
import { css } from 'emotion'
import { get } from 'lodash'
import * as React from 'react'

import { filterStyleCompact, PublicClassNames } from 'embed/constants'

// Filters
import DepositAmount from 'embed/components/filters/DepositAmount'
import { DepositsProductType } from 'embed/components/filters/DepositsProductType'
import Zipcode from 'embed/components/filters/Zipcode'

import FilterModal from 'embed/components/FilterModal'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { Filter, Filters } from 'even-ts-static'
const formStyles = require('embed/components/Form/styles.scss')
const filterStyles = require('embed/styles/filters')

export interface Props {
  defaultDepositsProductType?: string
  filters?: Filters
  onChange: (fieldName: Filter, value, isValid: boolean, userInitiated?: boolean) => void
  viewportHeight?: number
}

const InputStyles = {
  field: filterStyles.field,
  fieldError: formStyles.fieldError,
  fieldErrorMessage: formStyles.fieldErrorMessage,
  fieldFocus: formStyles.fieldFocus,
  fieldInput: filterStyles.input,
  fieldLabel: classnames(PublicClassNames.FormLabel, filterStyles.label),
}

const DropdownStyles = {
  dropDown: filterStyles.field,
  dropDownLabel: filterStyles.label,
  fieldError: formStyles.fieldError,
}

const Render: React.FC<Props> = ({ defaultDepositsProductType, filters, onChange }) => {
  const useFilterModal = filterStyleCompact()

  const inputContainerClass = useFilterModal
    ? filterStyles.modalInputContainer
    : classnames(filterStyles.container, filterStyles.threeFiltersWide)

  const inputs = (
    <>
      <Zipcode
        containerClass={classnames(PublicClassNames.FormInput, inputContainerClass)}
        onChange={onChange}
        styles={InputStyles}
        value={get(filters, Filter.Zipcode)}
      />
      <DepositAmount
        containerClass={classnames(PublicClassNames.FormDropdown, inputContainerClass)}
        onChange={onChange}
        styles={DropdownStyles}
        value={get(filters, Filter.DepositAmountIntentRange)}
      />
      <DepositsProductType
        containerClass={classnames(PublicClassNames.FormDropdown, inputContainerClass)}
        onChange={onChange}
        styles={DropdownStyles}
        startingValue={get(filters, Filter.ProductSubType, defaultDepositsProductType)}
      />
    </>
  )

  if (!useFilterModal) {
    return (
      <ThemeConsumer>
        {({ borderRadiusLarge, backdropStyles, boxStyles, colorBorder }) => (
          <div
            className={classnames(
              PublicClassNames.FilterContainer,
              filterStyles.filtersWrapper,
              css`
                background-color: ${backdropStyles.backgroundColor};
                border-color: ${colorBorder};
                border-radius: ${borderRadiusLarge};
              `,
            )}
            style={boxStyles}
          >
            {inputs}
          </div>
        )}
      </ThemeConsumer>
    )
  } else {
    return <FilterModal className={filterStyles.modalButton}>{inputs}</FilterModal>
  }
}

export default Render
